export default [
  {
    title: 'Dashboard',
    icon: 'HomeIcon',
    route: 'dashboard',
    resource: 'menu',
    action: 'dashboard'
  },
  {
    title: 'menu-reports',
    icon: 'BarChartIcon',
    route: 'automatic-reports',
    resource: 'automatic-reports',
    action: 'list'
  },
  {
    title: 'menu-deliveries',
    svg: true,
    children: [
      {
        title: 'menu-deliveries-create',
        route: {
          path: '/deliveries/create',
          hash: 'create'
        },
        resource: 'deliveries',
        action: 'create'
      },
      {
        title: 'menu-deliveries-list',
        route: 'deliveries-list',
        resource: 'deliveries',
        action: 'list'
      },
      {
        title: 'menu-deliveries-summaries',
        route: {
          path: '/deliveries/create',
          hash: 'summaries'
        },
        resource: 'deliveries',
        action: 'create'
      }
    ]
  },
  {
    title: 'menu-deliveries-flash',
    icon: 'ZapIcon',
    resource: 'menu',
    action: 'envia-flash',
    children: [
      {
        title: 'menu-deliveries-flash-create',
        route: 'envia-flash',
        resource: 'envia-flash',
        action: 'create'
      },
      {
        title: 'menu-deliveries-flash-config',
        route: 'envia-flash-config',
        resource: 'envia-flash',
        action: 'config'
      }
    ]
  },
  {
    title: 'menu-returns',
    icon: 'CornerUpLeftIcon',
    resource: 'menu',
    action: 'returns',
    children: [
      {
        title: 'menu-returns-create',
        route: 'returns',
        resource: 'returns',
        action: 'create'
      },
      {
        title: 'menu-returns-list',
        route: 'returns-list',
        resource: 'returns',
        action: 'list'
      }
    ]
  },
  {
    title: 'menu-marketcenter',
    icon: 'ShoppingCartIcon',
    children: [
      {
        title: 'menu-marketcenter-canal',
        route: 'marketcenter',
        resource: 'marketcenter',
        action: 'config'
      },
      {
        title: 'menu-marketcenter-deliveries',
        route: 'marketcenter-deliveries',
        resource: 'marketcenter',
        action: 'deliveries'
      },
      {
        title: 'menu-marketcenter-products',
        route: 'marketcenter-products',
        resource: 'marketcenter',
        action: 'products'
      }
    ]
  },
  {
    title: 'menu-carrier',
    icon: 'TruckIcon',
    resource: 'menu',
    action: 'carriers',
    children: [
      {
        title: 'menu-eva-agent',
        route: 'eva-agent',
        resource: 'carriers',
        action: 'eva-agent',
        tag: {
          label: 'Beta',
          variant: 'warning'
        }
      },
      {
        title: 'menu-courier-catalog',
        route: 'couriers-catalog',
        resource: 'carriers',
        action: 'carrier-client'
      },
      {
        title: 'menu-courier-code',
        route: {
          path: '/couriers/:id'
        },
        resource: 'carriers',
        action: 'carrier-client'
      }
    ]
  },
  {
    title: 'menu-pudos',
    icon: 'MapPinIcon',
    route: 'pudos',
    resource: 'pudos',
    action: 'list'
  },
  {
    title: 'menu-tickets',
    // icon: 'FileTextIcon',
    svg: true,
    resource: 'menu',
    action: 'tickets',
    children: [
      {
        title: 'menu-tickets-pending',
        route: 'tickets-pending',
        resource: 'tickets',
        action: 'pending'
      },
      {
        title: 'menu-tickets-assignments',
        route: 'assign-user',
        resource: 'tickets',
        action: 'assignments'
      },
      {
        title: 'menu-tickets-panel',
        route: 'tickets-madagascar',
        resource: 'tickets',
        action: 'detail'
      }
    ]
  },
  {
    title: 'menu-rules-tickets',
    // icon: 'ClipboardIcon',
    svg: true,
    resource: 'menu',
    action: 'rule-tickets',
    children: [
      {
        title: 'menu-rules-tickets-list',
        route: 'tm-rule-list',
        resource: 'rule-tickets',
        action: 'list'
      },
      {
        title: 'menu-rules-tickets-create',
        route: 'tm-rule-create',
        resource: 'rule-tickets',
        action: 'create'
      },
      {
        title: 'menu-rules-tickets-group-list',
        route: 'tm-group-list',
        resource: 'rule-tickets',
        action: 'groups'
      },
      {
        title: 'menu-rules-tickets-group-create',
        route: 'tm-group-create',
        resource: 'rule-tickets',
        action: 'create-group'
      }
    ]
  },
  {
    title: 'menu-rules',
    svg: true,
    route: 'advanced-rules-list',
    resource: 'advanced-rules',
    action: 'list'
  },
  // Falta back para poder listar los productos complementarios
  /* {
    title: 'menu-complementary-products',
    icon: 'ShoppingCartIcon',
    route: 'complementary-products',
    resource: 'menu',
    action: 'complementary-products'
  }, */
  {
    title: 'menu-materials',
    // icon: 'ArchiveIcon',
    svg: true,
    route: 'materials',
    resource: 'materials',
    action: 'list'
  },
  {
    title: 'menu-marketplace',
    svg: true,
    route: {
      path: '/companies/:id'
    },
    resource: 'companies',
    action: 'details'
  },
  {
    title: 'menu-companies',
    svg: true,
    route: 'companies',
    resource: 'companies',
    action: 'list'
  },
  {
    title: 'menu-billing',
    svg: true,
    //icon: 'FileIcon',
    route: {
      path: '/billing/:id'
    },
    resource: 'support',
    action: 'info'
  },
  //{
  //  title: 'menu-cash',
  //  icon: 'FileIcon',
  //  route: {
  //    path: '/recaudos/:id'
  //  },
  //  resource: 'recaudos',
  //  action: 'list'
  //},
  {
    title: 'menu-pricing-tariff',
    // icon: 'DollarSignIcon',
    svg: true,
    route: 'tariff-calculator',
    resource: 'pricing',
    action: 'calculator'
  },
  {
    title: 'menu-support',
    svg: true,
    route: 'support',
    resource: 'support',
    action: 'info'
  }

  // {
  //   title: 'menu-cyber-form',
  //   svg: true,
  //   route: 'cyber-form',
  //   resource: 'menu',
  //   action: 'dashboard',
  //   shipperCountry: ['CL'],
  //   organizationCountry: ['CL'],
  //   organizationIdHidden: [1162, 7551] // 1162 Cenco Mkp, 7551 Walmart Mkp
  // }
]
